"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultClient = exports.FeatureFlagClient = void 0;
var eventemitter3_1 = __importDefault(require("eventemitter3"));
var launchdarkly_js_client_sdk_1 = require("launchdarkly-js-client-sdk");
var lodash_debounce_1 = __importDefault(require("lodash.debounce"));
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var partner_tools_1 = require("@melio/partner-tools");
var VARIANT_TRACK_WAIT = 500;
var CLIENT_INITIALIZED_EVENT = 'CLIENT_INITIALIZED_EVENT';
var CLIENT_INITIALIZATION_ERRORED_EVENT = 'CLIENT_INITIALIZATION_ERRORED_EVENT';
var CLIENT_IDENTIFIED_EVENT = 'CLIENT_IDENTIFIED_EVENT';
var CLIENT_IDENTIFICATION_ERRORED_EVENT = 'CLIENT_IDENTIFICATION_ERRORED_EVENT';
var FeatureFlagClient = /** @class */ (function () {
    function FeatureFlagClient() {
        var _this = this;
        this.trackersMap = {};
        this.$clientInitialized = false;
        this.$clientInitializationErrored = false;
        this.$clientIdentified = false;
        this.$clientIdentificationErrored = false;
        this.emitter = new eventemitter3_1.default();
        this.initFlagTracking = function (flagNameToInit) {
            if (_this.trackersMap[flagNameToInit]) {
                return;
            }
            _this.trackersMap[flagNameToInit] = (0, lodash_debounce_1.default)(function (flagName, variant) {
                _this.initialTrackVariant(flagName, variant);
            }, VARIANT_TRACK_WAIT);
        };
        this.trackVariant = function (flagName, value) {
            if (!_this.initialTrackVariant) {
                return;
            }
            _this.initFlagTracking(flagName);
            _this.trackersMap[flagName](flagName, value);
        };
    }
    Object.defineProperty(FeatureFlagClient.prototype, "clientInitialized", {
        get: function () {
            return this.$clientInitialized;
        },
        set: function (value) {
            this.$clientInitialized = value;
            this.emitter.emit(CLIENT_INITIALIZED_EVENT, this.$clientInitialized);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureFlagClient.prototype, "clientIdentified", {
        get: function () {
            return this.$clientIdentified;
        },
        set: function (value) {
            this.$clientIdentified = value;
            this.emitter.emit(CLIENT_IDENTIFIED_EVENT, this.$clientIdentified);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureFlagClient.prototype, "clientInitializationErrored", {
        get: function () {
            return this.$clientInitializationErrored;
        },
        set: function (value) {
            this.$clientInitializationErrored = value;
            this.emitter.emit(CLIENT_INITIALIZATION_ERRORED_EVENT, this.$clientInitializationErrored);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeatureFlagClient.prototype, "clientIdentificationErrored", {
        get: function () {
            return this.$clientIdentificationErrored;
        },
        set: function (value) {
            this.$clientIdentificationErrored = value;
            this.emitter.emit(CLIENT_IDENTIFICATION_ERRORED_EVENT, this.$clientIdentificationErrored);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Initialize the feature flag client
     * When you initialize the client it'll authenticate with LaunchDarkly as an anonymous user
     * @param options -
     *     clientId: string - the launchdarkly clientId for the respective environment
     *     trackVariant: (variantName: string, value: any, reportLeadingCall: boolean) => any;
     *      - when a variant is chosen, we want to notify analytics. This is the function the client will call
     *          when such a thing happens.
     *     proxyUrl?: string - a url for launchdarkly proxy - to be used to overcome ad blockers
     */
    FeatureFlagClient.prototype.initialize = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clientId = options.clientId;
                        this.initialTrackVariant = options.trackVariant;
                        this.proxyUrl = options.proxyUrl;
                        this.identifier = buildAnonymousIdentifier(options.environmentName, options.channelName);
                        this.anonymousId = getAnonymousId();
                        this.ldclient = (0, launchdarkly_js_client_sdk_1.initialize)(this.clientId, this.identifier, { baseUrl: this.proxyUrl });
                        this.initPromise = this.ldclient.waitForInitialization();
                        this.relevantFlags = options.relevantFlags;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.initPromise];
                    case 2:
                        _a.sent();
                        this.clientInitialized = true;
                        this.clientInitializationErrored = false;
                        this.storeFlagValuesOnSession();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.clientInitializationErrored = true;
                        throw new Error('failed to init LD client');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Identifies the user and organization
     * This starts a process of getting the rules from launchdarkly, so the client will not be ready until
     * the process finishes
     * @param user
     * @param organization
     * @param channelName
     * @param environmentName
     */
    FeatureFlagClient.prototype.identify = function (user, organization, channelName, environmentName) {
        return __awaiter(this, void 0, void 0, function () {
            var identity, hasSameIdentity, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        identity = buildIdentifier(user, organization, channelName, environmentName, this.anonymousId);
                        hasSameIdentity = (0, lodash_isequal_1.default)(this.identifier, identity);
                        this.clientIdentified = this.clientIdentified && hasSameIdentity;
                        return [4 /*yield*/, this.initPromise];
                    case 1:
                        _a.sent();
                        if (!!hasSameIdentity) return [3 /*break*/, 3];
                        this.identifier = identity;
                        return [4 /*yield*/, this.ldclient.identify(identity)];
                    case 2:
                        _a.sent();
                        this.clientIdentified = true;
                        this.clientIdentificationErrored = false;
                        this.storeFlagValuesOnSession();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.error('launchdarkly user client failed to identify', err_1);
                        this.clientIdentificationErrored = true;
                        throw err_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    FeatureFlagClient.prototype.storeFlagValuesOnSession = function () {
        var _this = this;
        var allFlags = this.ldclient.allFlags();
        var filteredFlags = this.relevantFlags
            ? Object.fromEntries(Object.entries(allFlags).filter(function (_a) {
                var _b;
                var flagKey = _a[0];
                return (_b = _this.relevantFlags) === null || _b === void 0 ? void 0 : _b.includes(flagKey);
            }))
            : allFlags;
        window.sessionStorage.setItem('melio-internal-ff-values', JSON.stringify(filteredFlags));
    };
    FeatureFlagClient.prototype.hasOverride = function (flagName) {
        return (window === null || window === void 0 ? void 0 : window.sessionStorage.getItem("feature-override-".concat(flagName))) !== null;
    };
    FeatureFlagClient.prototype.getVariantNoTrack = function (flagName, defaultValue) {
        var featureOverride = window === null || window === void 0 ? void 0 : window.sessionStorage.getItem("feature-override-".concat(flagName));
        if (featureOverride != null) {
            return JSON.parse(featureOverride);
        }
        if (!this.clientInitialized) {
            return defaultValue;
        }
        var value = this.ldclient.variation(flagName, defaultValue);
        return value;
    };
    /**
     * Returns the value for the variant of the flagName.
     * Will call trackVariant callback on every call, so make sure to cache the value instead of calling each time.
     * @param flagName
     * @param defaultValue - default value if the client was not initialized
     */
    FeatureFlagClient.prototype.getVariant = function (flagName, defaultValue) {
        var value = this.getVariantNoTrack(flagName, defaultValue);
        this.initialTrackVariant && this.initialTrackVariant(flagName, value);
        return value;
    };
    /**
     * Listen to changes on client initialization.
     * Needed for integration with react effect listeners and such
     * @param handler - will be called every time the initialization status changes, with the boolean initialized value
     * @returns an unsubscribe function
     */
    FeatureFlagClient.prototype.onInitializeEvent = function (handler) {
        var _this = this;
        this.emitter.on(CLIENT_INITIALIZED_EVENT, handler);
        return function () {
            _this.emitter.off(CLIENT_INITIALIZED_EVENT, handler);
        };
    };
    FeatureFlagClient.prototype.onIdentifiedEvent = function (handler) {
        var _this = this;
        this.emitter.on(CLIENT_IDENTIFIED_EVENT, handler);
        return function () {
            _this.emitter.off(CLIENT_IDENTIFIED_EVENT, handler);
        };
    };
    FeatureFlagClient.prototype.onInitializationErroredEvent = function (handler) {
        var _this = this;
        this.emitter.on(CLIENT_INITIALIZATION_ERRORED_EVENT, handler);
        return function () {
            _this.emitter.off(CLIENT_INITIALIZATION_ERRORED_EVENT, handler);
        };
    };
    FeatureFlagClient.prototype.onIdentificationErroredEvent = function (handler) {
        var _this = this;
        this.emitter.on(CLIENT_IDENTIFICATION_ERRORED_EVENT, handler);
        return function () {
            _this.emitter.off(CLIENT_IDENTIFICATION_ERRORED_EVENT, handler);
        };
    };
    return FeatureFlagClient;
}());
exports.FeatureFlagClient = FeatureFlagClient;
function buildIdentifier(user, organization, channelName, environmentName, anonymousId) {
    var partnerGroup = (0, partner_tools_1.partnerGroupParser)(channelName).partnerGroup;
    return __assign(__assign(__assign(__assign(__assign({ kind: 'user', key: "organization-".concat(organization.id), userId: user.id, anonymousId: anonymousId, organizationId: organization.id }, (environmentName && { environmentName: environmentName })), (channelName && { channelName: channelName, partnerGroup: partnerGroup })), (organization.companyType && { companyType: organization.companyType })), (user.email && { userEmail: user.email })), (user.createdAt &&
        !Number.isNaN(new Date(user.createdAt).valueOf()) && { userCreatedAt: new Date(user.createdAt).getTime() }));
}
function buildAnonymousIdentifier(environmentName, channelName) {
    var anonymousId = getAnonymousId();
    var partnerGroup = (channelName ? (0, partner_tools_1.partnerGroupParser)(channelName) : { partnerGroup: null }).partnerGroup;
    return __assign(__assign({ kind: 'user', key: "anonymous", anonymous: true, anonymousId: anonymousId }, (channelName && { channelName: channelName, partnerGroup: partnerGroup })), (environmentName && { environmentName: environmentName }));
}
function getAnalyticsAnonymousId() {
    var _a, _b, _c, _d;
    try {
        // @ts-expect-error untyped analytics user
        var analyticsId = (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.analytics) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.anonymousId) === null || _d === void 0 ? void 0 : _d.call(_c);
        if (analyticsId) {
            return analyticsId;
        }
    }
    catch (e) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        console.error('Bad analytics object', window.analytics);
    }
    return null;
}
function getAnonymousId() {
    var analyticsAnonymousId = getAnalyticsAnonymousId();
    if (analyticsAnonymousId) {
        return analyticsAnonymousId;
    }
    var id = window === null || window === void 0 ? void 0 : window.localStorage.getItem('asyncAnonymousId');
    if (!id) {
        id = randomId();
        window === null || window === void 0 ? void 0 : window.localStorage.setItem('asyncAnonymousId', id.toString());
    }
    return id;
}
function randomId() {
    return "".concat(new Date().getTime()).concat(Math.floor(Math.random() * 10000));
}
/**
 * A default client is provided for simplicity of use
 */
exports.defaultClient = new FeatureFlagClient();
